import { render, staticRenderFns } from "./OpenItem.vue?vue&type=template&id=df7bf16c&scoped=true"
import script from "./OpenItem.vue?vue&type=script&lang=js"
export * from "./OpenItem.vue?vue&type=script&lang=js"
import style0 from "./OpenItem.vue?vue&type=style&index=0&id=df7bf16c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7bf16c",
  null
  
)

export default component.exports